import type { Market, Partner } from 'BrokerTsLib/src/enums'

import { AllianzKontakt } from './AllianzKontakt'
import { AndyAuto } from './AndyAuto'
import { BmwFs, BMWFSSK } from './BmwFs'
import { BusinessLease } from './BusinessLease'
import { Allrisk, CommonClient, LeasePlan, LeasingCS, MBFSSK, UCLSK, UniCreditLeasing } from './CommonClient'
import { Davocar } from './Davocar'
import { AutoEsa, DirectAuto, Essox } from './Essox'
import { Jap } from './Jap'
import { Kapitol } from './Kapitol'
import { Respect } from './Respect'
import { RLCZ } from './RLCZ'
import { TUkas } from './TUkas'
import { VWFS } from './VWFS'

export * from './BusinessLease'
export * from './CommonClient'
export * from './Jap'
export * from './Kapitol'
export * from './Respect'
export * from './RLCZ'
export * from './TUkas'

export const Partners = [CommonClient, Jap, Kapitol, BmwFs, Respect, AndyAuto, LeasePlan, Davocar, AllianzKontakt, Essox, AutoEsa, DirectAuto, RLCZ, BusinessLease, TUkas, UniCreditLeasing, LeasingCS, VWFS, UCLSK, BMWFSSK, MBFSSK, Allrisk]

export interface IPartnerSettings {
  partner: keyof typeof Partner
  hosts: string[] // pro detekci partnera na zaklade URL
  deployment?: keyof typeof Partner // pro nastaveni spravneho environmentu pro partnerske deploye (JAP, KAP, ESSOX...)
  logo?: string // pro zobrazeni loga partnera
  market: Market
}

export const getPartnerByHost = (): IPartnerSettings | undefined => Partners.find((x) => x.hosts.indexOf(window.window.location.host) >= 0)

export const getPartnerByKey = (key: keyof typeof Partner): IPartnerSettings | undefined => Partners.find((x) => x.partner == key)
